console.log('categories loading');
export const categories = [
    {
        "id": 1,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Allergy and Immunology",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 3,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Dermatology",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 2,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Pain Management",
        "sector": "specialty",
        "keywords": null
    },    
    {
        "id": 4,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Acute Medicine",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 5,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "General Medicine",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 6,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Neurology/Stroke",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 7,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Obstetrics & Gynecology",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 8,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Ophthalmology",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 9,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Paediatrics/Adolescent Medicine",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 10,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Physiotherapist",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 11,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Psychiatry",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 12,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Oncology/Haematologist",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 13,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "General Surgery",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 14,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Urology",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 15,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Orthopaedic Surgeon",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 16,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Cardiologist/Heart Specialist",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 17,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Pulminologist/Lung Specialist",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 18,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Nephrologist/Kidney Specialist",
        "sector": "specialty",
        "keywords": null
    },
    {
        "id": 19,
        "image": "https://images.pexels.com/photos/6320167/pexels-photo-6320167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        "title": "Infectious Disease Specialist",
        "sector": "specialty",
        "keywords": null
    }
]